/**
 * Rich Text Editor classes defined here.
 */
/**
 * @hidden
 * @private
 */
export const CLASS_IMAGE_RIGHT = 'e-imgright';
export const CLASS_IMAGE_LEFT = 'e-imgleft';
export const CLASS_IMAGE_CENTER = 'e-imgcenter';
export const CLASS_VIDEO_RIGHT = 'e-video-right';
export const CLASS_VIDEO_LEFT = 'e-video-left';
export const CLASS_VIDEO_CENTER = 'e-video-center';
export const CLASS_IMAGE_BREAK = 'e-imgbreak';
export const CLASS_AUDIO_BREAK = 'e-audio-break';
export const CLASS_VIDEO_BREAK = 'e-video-break';
export const CLASS_CAPTION = 'e-img-caption';
export const CLASS_IMAGE_LEFT_WRAP = 'e-img-left-wrap';
export const CLASS_IMAGE_RIGHT_WRAP = 'e-img-right-wrap';
export const CLASS_RTE_CAPTION = 'e-rte-img-caption';
export const CLASS_CAPTION_INLINE = 'e-caption-inline';
export const CLASS_IMAGE_INLINE = 'e-imginline';
export const CLASS_AUDIO_INLINE = 'e-audio-inline';
export const CLASS_CLICK_ELEM = 'e-clickelem';
export const CLASS_VIDEO_CLICK_ELEM = 'e-video-clickelem';
export const CLASS_AUDIO = 'e-rte-audio';
export const CLASS_VIDEO = 'e-rte-video';
export const CLASS_AUDIO_WRAP = 'e-audio-wrap';
export const CLASS_VIDEO_WRAP = 'e-video-wrap';
export const CLASS_EMBED_VIDEO_WRAP = 'e-embed-video-wrap';
export const CLASS_AUDIO_FOCUS = 'e-audio-focus';
export const CLASS_VIDEO_FOCUS = 'e-video-focus';
export const CLASS_VIDEO_INLINE = 'e-video-inline';
